import type { PaymentMethodDialogSession } from "@/components/billing/PaymentMethodDialog";
import { createContext, useContext } from "react";

export type OpenPaymentMethodDialog = (
  session: PaymentMethodDialogSession,
) => void;

const PaymentMethodDialogContext =
  createContext<OpenPaymentMethodDialog | null>(null);

/**
 * Null when no provider is mounted, so the caller can fall back to the checkout
 * page. Deliberately unlike `useOpenManagePlan`, which returns a no-op: a no-op
 * here would swallow the click on /billing/* and /onboarding/*.
 */
export function useOpenPaymentMethodDialog(): OpenPaymentMethodDialog | null {
  return useContext(PaymentMethodDialogContext);
}

export const PaymentMethodDialogProvider = PaymentMethodDialogContext.Provider;
